<!-- 图片广告 -->
<template>
    <div class="h100">
        <div class="h100" v-if="imageData.content.style_id == 0">
            <div class="img-div wh100 position-relative">
                <img class="wh100 of-c" v-if="imageData.content.imgList[0].picview"
                    :style="`border-radius: ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px ${imageData.content.marginData.bottomRadius}px;`"
                    :src="imageData.content.imgList[0].picview"
                />
                <div v-else class="wh100 of-c" :style="`border-radius: ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px ${imageData.content.marginData.bottomRadius}px;`"></div>
            </div>
        </div>
        <div class="dis-flex h100" v-if="imageData.content.style_id == 1">
            <div class="img-div h100 w33">
                <img v-if="imageData.content.imgList[0].picview" class="wh100 of-c"
                    :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`"
                    :src="imageData.content.imgList[0].picview"
                />
                <div v-else class="wh100 of-c" :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`"></div>
            </div>
            <div class="img-div h100 w66">
                <img v-if="imageData.content.imgList[1].picview" class="wh100 of-c"
                    :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px 0;`"
                    :src="imageData.content.imgList[1].picview"
                />
                <div v-else class="wh100 of-c" :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px 0;`"></div>
            </div>
        </div>
        <div class="dis-flex h100" v-if="imageData.content.style_id == 2">
            <div class="img-div h100 w33">
                <img v-if="imageData.content.imgList[0].picview" class="wh100 of-c"
                    :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`"
                    :src="imageData.content.imgList[0].picview"
                />
                <div v-else class="wh100 of-c" :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`"></div>
            </div>
            <div class="h100 w66">
                <div class="img-div h50 w100">
                    <img v-if="imageData.content.imgList[1].picview" class="wh100 of-c"
                        :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px 0 0;`"
                        :src="imageData.content.imgList[1].picview"
                    />
                    <div v-else class="wh100 of-c" :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px 0 0;`"></div>
                </div>
                <div class="img-div w100 h50">
                    <img v-if="imageData.content.imgList[2].picview" class="wh100 of-c"
                        :style="`border-radius: 0 0 ${imageData.content.marginData.bottomRadius}px 0;`"
                        :src="imageData.content.imgList[2].picview"
                    />
                    <div v-else class="wh100 of-c" :style="`border-radius: 0 0 ${imageData.content.marginData.bottomRadius}px 0;`"></div>
                </div>
            </div>
        </div>
        <div class="dis-flex h100" v-if="imageData.content.style_id == 3">
            <div class="img-div h100 w33">
                <img v-if="imageData.content.imgList[0].picview" class="wh100 of-c"
                    :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`"
                    :src="imageData.content.imgList[0].picview"
                />
                <div v-else class="wh100 of-c" :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`"></div>
            </div>
            <div class="w66 h100">
                <div class="img-div w100 h50">
                    <img v-if="imageData.content.imgList[1].picview" class="wh100 of-c"
                        :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px 0 0;`"
                        :src="imageData.content.imgList[1].picview"
                    />
                    <div v-else class="wh100 of-c" :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px 0 0;`"></div>
                </div>
                <div class="dis-flex h100">
                    <div class="img-div w50 h50">
                        <img v-if="imageData.content.imgList[2].picview" class="wh100 of-c br-0" :src="imageData.content.imgList[2].picview"/>
                        <div v-else class="wh100 of-c br-0"></div>
                    </div>
                    <div class="img-div w50 h50">
                        <img v-if="imageData.content.imgList[3].picview" class="wh100 of-c"
                            :style="`border-radius: 0 0 ${imageData.content.marginData.bottomRadius}px 0;`"
                            :src="imageData.content.imgList[3].picview"
                        />
                        <div v-else class="wh100 of-c" :style="`border-radius: 0 0 ${imageData.content.marginData.bottomRadius}px 0;`"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dis-flex h100" v-if="imageData.content.style_id == 4">
            <div class="img-div w50 h100">
                <img v-if="imageData.content.imgList[0].picview" class="wh100 of-c"
                    :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`"
                    :src="imageData.content.imgList[0].picview"
                />
                <div v-else class="wh100 of-c" :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`"></div>
            </div>
            <div class="img-div w50 h100">
                <img v-if="imageData.content.imgList[1].picview" class="wh100 of-c"
                    :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px 0;`"
                    :src="imageData.content.imgList[1].picview"
                />
                <div v-else class="wh100 of-c" :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px 0;`"></div>
            </div>
        </div>
        <div class="dis-flex h100" v-if="imageData.content.style_id == 5">
            <div class="img-div w33 h100">
                <img v-if="imageData.content.imgList[0].picview" class="wh100 of-c"
                    :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`"
                    :src="imageData.content.imgList[0].picview"
                />
                <div v-else class="wh100 of-c" :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`"></div>
            </div>
            <div class="img-div w33 h100">
                <img v-if="imageData.content.imgList[1].picview" class="wh100 of-c br-0" :src="imageData.content.imgList[1].picview"/>
                <div v-else class="wh100 of-c br-0"></div>
            </div>
            <div class="img-div w33 h100">
                <img v-if="imageData.content.imgList[2].picview" class="wh100 of-c"
                    :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px 0;`"
                    :src="imageData.content.imgList[2].picview"
                />
                <div v-else class="wh100 of-c" :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px 0;`"></div>
            </div>
        </div>
        <div class="dis-flex h100" v-if="imageData.content.style_id == 6">
            <div class="img-div w25 h100">
                <img v-if="imageData.content.imgList[0].picview" class="wh100 of-c"
                    :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`"
                    :src="imageData.content.imgList[0].picview"
                />
                <div v-else class="wh100 of-c" :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 ${imageData.content.marginData.bottomRadius}px;`"></div>
            </div>
            <div class="img-div w25 h100">
                <img v-if="imageData.content.imgList[1].picview" class="wh100 of-c br-0" :src="imageData.content.imgList[1].picview"/>
                <div v-else class="wh100 of-c br-0"></div>
            </div>
            <div class="img-div w25 h100">
                <img v-if="imageData.content.imgList[2].picview" class="wh100 of-c br-0" :src="imageData.content.imgList[2].picview"/>
                <div v-else class="wh100 of-c br-0"></div>
            </div>
            <div class="img-div w25 h100">
                <img v-if="imageData.content.imgList[3].picview" class="wh100 of-c"
                    :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px 0;`"
                    :src="imageData.content.imgList[3].picview"
                />
                <div v-else class="wh100 of-c" :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px ${imageData.content.marginData.bottomRadius}px 0;`"></div>
            </div>
        </div>
        <div class="h100" v-if="imageData.content.style_id == 7">
            <div class="w100 h50 dis-flex">
                <div class="img-div w50 h100">
                    <img v-if="imageData.content.imgList[0].picview" class="wh100 of-c"
                        :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 0;`"
                        :src="imageData.content.imgList[0].picview"
                    />
                    <div v-else class="wh100 of-c" :style="`border-radius: ${imageData.content.marginData.topRadius}px 0 0 0;`"></div>
                </div>
                <div class="img-div w50 h100">
                    <img v-if="imageData.content.imgList[1].picview" class="wh100 of-c"
                        :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px 0 0;`"
                        :src="imageData.content.imgList[1].picview"
                    />
                    <div v-else class="wh100 of-c" :style="`border-radius: 0 ${imageData.content.marginData.topRadius}px 0 0;`"></div>
                </div>
            </div>
            <div class="w100 h50 dis-flex">
                <div class="img-div w50 h100">
                    <img v-if="imageData.content.imgList[2].picview" class="wh100 of-c"
                        :style="`border-radius: 0 0 0 ${imageData.content.marginData.bottomRadius}px;`"
                        :src="imageData.content.imgList[2].picview"
                    />
                    <div v-else class="wh100 of-c" :style="`border-radius: 0 0 0 ${imageData.content.marginData.bottomRadius}px;`"></div>
                </div>
                <div class="img-div w50 h100">
                    <img v-if="imageData.content.imgList[3].picview" class="wh100 of-c"
                        :style="`border-radius: 0 0 ${imageData.content.marginData.bottomRadius}px 0;`"
                        :src="imageData.content.imgList[3].picview"
                    />
                    <div v-else class="wh100 of-c" :style="`border-radius: 0 0 ${imageData.content.marginData.bottomRadius}px 0;`"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        imageData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    methods: {
    },
};
</script>

<style scoped>
img {
    pointer-events: none;
}
.img-div {
    border: 1px dashed #ccc;
}
.active {
    border: 2px dashed #ff761d;
}
.wh100 {
    width: 100%;
    height: 100%;
}
.w100 {
    width: 100%;
}
.w50 {
    width: 50%;
}
.w33 {
    width: 33.333%;
}
.w66 {
    width: 66.666%;
}
.w25 {
    width: 25%;
}
.h100 {
    height: 100%;
}
.h50 {
    height: 50%;
}
.position-relative {
    position: relative;
}
.of-c {
    background-color: #fff;
    object-fit: cover;
}
.dis-flex {
    display: flex;
}
.br-0 {
    border-radius: 0 0 0 0;
}
</style>